export enum USER_ACTION_TYPES {
  SET_CURRENT_USER = "currentUser/SET_CURRENT_USER",
}
